import { fileUrl } from "@/api";

const DIMS = {
  sm: "h-14 w-14 text-lg",
  md: "h-20 w-20 text-2xl",
  lg: "h-36 w-36 text-4xl",
  xl: "h-48 w-48 sm:h-60 sm:w-60 text-6xl",
};

export default function Portrait({ name = "", src = "", size = "md", className = "", testid }) {
  const initials = name
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase() || "?";
  const dims = DIMS[size] || DIMS.md;
  if (src) {
    return (
      <img
        src={fileUrl(src)}
        alt={`Portrait of ${name}`}
        loading="lazy"
        data-testid={testid}
        className={`${dims} rounded-full object-cover object-top ring-2 ring-gold/60 ${className}`}
      />
    );
  }
  return (
    <div
      aria-label={`Portrait placeholder for ${name}`}
      role="img"
      data-testid={testid}
      className={`${dims} rounded-full bg-navy-800 ring-2 ring-gold/60 flex items-center justify-center font-serif text-gold select-none ${className}`}
    >
      {initials}
    </div>
  );
}
